import { ARVORE_ROOT_PATH, API_ARVORE_ONBOARDING_URL } from 'config/vars'
import { getCookie } from 'utils/cookies'

export const customInstance = async <T>(
  url: string,
  config?: RequestInit
): Promise<T> => {
  const accessToken = getCookie('access_token')

  const headers: Record<string, string> = {
    ...(config?.body instanceof FormData
      ? {}
      : { 'Content-Type': 'application/json' }),
    ...((config?.headers as Record<string, string>) || {})
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const apiPath = process.env.FRONT_END_API_ARVORE_LOCAL ? '' : ARVORE_ROOT_PATH

  const response = await fetch(`${apiPath}${url}`, {
    ...config,
    headers
  })

  const contentType = response.headers.get('content-type')

  if (!response.ok) {
    const message = await response?.json()
    if (!message) {
      throw new Error(`Http Error: ${response.status}`)
    }

    throw new Error(message.message)
  }

  if (contentType && contentType.includes('application/json')) {
    const data = await response.json()
    return { data, status: response.status, headers: response.headers } as T
  }

  const data = await response.text()
  return { data, status: response.status, headers: response.headers } as T
}

export const onboardingCustomInstance = async <T>(
  url: string,
  config?: RequestInit
): Promise<T> => {
  const accessToken = getCookie('access_token')

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((config?.headers as Record<string, string>) || {})
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = await fetch(`${API_ARVORE_ONBOARDING_URL}${url}`, {
    ...config,
    headers
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const contentType = response.headers.get('content-type')
  const text = await response.text()

  let data: unknown
  if (text && contentType?.includes('application/json')) {
    data = JSON.parse(text)
  } else if (text) {
    data = text
  } else {
    data = null
  }

  return { data, status: response.status, headers: response.headers } as T
}

export default customInstance
